import { render, staticRenderFns } from "./PageFifteenth.vue?vue&type=template&id=6a13113f&scoped=true"
import script from "./PageFifteenth.vue?vue&type=script&lang=js"
export * from "./PageFifteenth.vue?vue&type=script&lang=js"
import style0 from "./PageFifteenth.vue?vue&type=style&index=0&id=6a13113f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a13113f",
  null
  
)

export default component.exports